





































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import _ from "lodash";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import { useEmployerRolePermissionStore } from "@/admin/store/employerRolePermission";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    Button
  }
})
export default class EmployerRolePermissions extends Vue {
  $validator: Validator;

  employerRolePermissionStore = useEmployerRolePermissionStore();
  rolePermissionsStore = useRolePermissionsStore();
  sticky = false;
  editMode = false;
  editedPermissionIds = {};
  roleCells = [];

  mounted (): void {
    this.employerRolePermissionStore.getRolePermissions();
  }

  get tableFields (): { key: string, label: string }[] {
    const fields = [ { key: "permissionName", label: "Name" } ];

    if (!this.employerRolePermissionStore.isLoaded) {
      return fields;
    }

    const employerPermissionRoles = this.employerRolePermissionStore.employerRolePermissions[0].roles;

    if (employerPermissionRoles) {
      const formattedHeaderCells = employerPermissionRoles.map(x => {
        return {
          key: `${x.roleId}`,
          label: x.roleName
        };
      });

      this.roleCells = formattedHeaderCells;

      return [
        ...fields,
        ...formattedHeaderCells
      ];
    }

    return fields;
  }

  get flattenedData () {
    const flatData = [];
    this.employerRolePermissionStore.employerRolePermissions.forEach(element => {
      const roles = element.roles;

      const formattedObject = {
        permissionId: element.permissionId,
        permissionName: element.permissionName,
      };

      roles.forEach(x => {
        formattedObject[`${x.roleId}`] = x.isEnabled;
      });

      flatData.push(formattedObject);
    });

    return flatData;
  }

  get isSaveDisabled (): boolean {
    return this.employerRolePermissionStore.isPosting || !this.editMode;
  }

  markItemAsChanged (id: string) {
    this.editedPermissionIds[id] = id;
  }

  saveChanges (): void {
    const editedPermissions = _.filter(this.employerRolePermissionStore.employerRolePermissions,
        x => _.includes(this.editedPermissionIds, x.permissionId));

    // clone flatData model, as it is mutated back to original state during iteration of the next foreach
    // clone preserves original state allowing multiple rows to be updated correctly
    const flatDataClone = [ ...this.flattenedData ];

    editedPermissions.forEach(x => {
      const flattenedRow = _.find(flatDataClone, y => y.permissionId === x.permissionId);

      x.roles.forEach(element => {
        element.isEnabled = flattenedRow[`${element.roleId}`];
      });
    });

    this.employerRolePermissionStore.saveRolePermissions(editedPermissions);
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityGlobalRolePermissionEdit);
  }
}
